import { makeStyles, createStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) =>
  createStyles({
    controlLabel: {
      marginLeft: 0,
      display: 'flex',
    },
    strongText: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
    },
    checkbox: {
      padding: 5,
      color: theme.palette.grey[400],

      '& svg': {
        height: 18,
        width: 18,
      },
    },
    formControl: {
      width: 350,
    },
    select: {
      height: '40px',
    },
    expandIcon: {
      height: 20,
      width: 20,
      color: '#687C8D',
      pointerEvents: 'none',
      position: 'absolute',
      top: 8,
      right: 10,
    },
  }),
);
